"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitAccountNameWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var DirectDebitAccountNameWidget = /** @class */ (function (_super) {
    __extends(DirectDebitAccountNameWidget, _super);
    function DirectDebitAccountNameWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState(function (state) { return ({
                modalOpened: !state.modalOpened
            }); });
        };
        _this.state = {
            modalOpened: false,
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    DirectDebitAccountNameWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        var policyHolderFullName = services_1.CommonHelpers.getPolicyHolderFullName(interaction);
        var accountHolderName = interaction.paymentDetails.directDebitDetails ? interaction.paymentDetails.directDebitDetails.accountHolderName : policyHolderFullName;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "pt-4" },
                React.createElement("p", { className: "font-weight-semi-bold mb-3" }, "Name of account holder"),
                React.createElement("p", null,
                    accountHolderName,
                    " ",
                    React.createElement("span", { onClick: this.toggle, className: "font-weight-semi-bold text-decoration-underlinecursor-pointer ml-2" }, "Need to change this?"))),
            this.renderModal()));
    };
    DirectDebitAccountNameWidget.prototype.renderModal = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggle });
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.modalOpened, toggle: this.toggle },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-button-width", src: "/img/Flow-warning-selected.svg", alt: "Warning icon" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Sorry..."))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("p", { className: "font-weight-semi-bold mb-3" }, "We can only set up direct debits from the policyholder\u2019s personal bank account."),
                React.createElement("p", null, "If this isn\u2019t possible, please choose another payment method.")),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement("div", { className: "row" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1 btn-next-no-arrow", onClick: this.toggle }, "Ok, I understand")))));
    };
    return DirectDebitAccountNameWidget;
}(plugin_journey_1.WidgetBase));
exports.DirectDebitAccountNameWidget = DirectDebitAccountNameWidget;
//# sourceMappingURL=DirectDebitAccountNamelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/directDebit/DirectDebitAccountNamelWidget.js
// module id = 3490
// module chunks = 0